{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Pipeline Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "license_no": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence No.",
      "folder": "Pipeline Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "line_segment_no": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Segment Line No.",
      "folder": "Pipeline Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "lic_li_no": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Line No.",
      "folder": "Pipeline Header",
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Pipeline Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "comp_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Company",
      "folder": "Pipeline Header",
      "width": 250,
      "isShownByDefault": true,
    },
  },
  "substance": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Substance",
      "folder": "Pipeline Header",
      "isShownByDefault": true,
    },
  },
  "seg_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Segment Status",
      "folder": "Pipeline Header",
      "isShownByDefault": true,
    },
  },
  "has_complaint": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Complaint",
      "folder": "Pipeline Header",
    },
  },
  "has_spill": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Spill",
      "folder": "Pipeline Header",
    },
  },
  "has_h2s": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has H2S",
      "folder": "Pipeline Header",
    },
  },
  "licence_approval_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Approval Date",
      "folder": "Pipeline Header",
    },
  },
  "seg_length": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Segment Length",
      "folder": "Pipeline Specs",
      "isShownByDefault": true,
    },
  },
  "pipe_outer_diameter": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mm",
    },
    "ui": {
      "label": "Outer Diameter",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_material": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Material",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_grade": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Grade",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_maop": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "kPa",
    },
    "ui": {
      "label": "MAOP",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Type",
      "folder": "Pipeline Specs",
    },
  },
  "permit_approval_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Permit Approval Date",
      "folder": "Pipeline Header",
    },
  },
  "original_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Original ID",
      "folder": "Pipeline Header",
      "tnum": true,
    },
  },
  "wall_thick": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mm",
    },
    "ui": {
      "label": "Wall Thickness",
      "folder": "Pipeline Specs",
    },
  },
  "ad_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "AD Number",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "legacy_ogc_file": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Legacy OGC File",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "product_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Product Code",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "category": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Category",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "line_type_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Line Type Code",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "abandonment_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Abandonment Date",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "operator_effective_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Operator Effective Date",
      "folder": "Pipeline Header",
      "subFolder": "BC Details",
    },
  },
  "license_issue_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Issue Date",
      "folder": "Pipeline Header",
    },
  },
  "h2s_content": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "H2S Content",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_joint_method": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Joint Method",
      "folder": "Pipeline Specs",
      "subFolder": "AB Specs",
    },
  },
  "co2_content": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "CO2 Content",
      "folder": "Pipeline Specs",
      "subFolder": "BC Specs",
    },
  },
  "is_surface_segment": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Surface Segment",
      "folder": "Pipeline Specs",
    },
  },
  "partial_pressure_kpa": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "kPa",
    },
    "ui": {
      "label": "Partial Pressure",
      "folder": "Pipeline Specs",
    },
  },
  "design_pressure_kpa": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "kPa",
    },
    "ui": {
      "label": "Design Pressure",
      "folder": "Pipeline Specs",
    },
  },
  "min_design_temp_c": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "C",
    },
    "ui": {
      "label": "Min Design Temp",
      "folder": "Pipeline Specs",
    },
  },
  "max_design_temp_c": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "C",
    },
    "ui": {
      "label": "Max Design Temp",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_internal_coating": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Internal Coating",
      "folder": "Pipeline Specs",
    },
  },
  "pipe_exterior_coating": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pipe Exterior Coating",
      "folder": "Pipeline Specs",
      "subFolder": "BC Specs",
    },
  },
  "cathodic_protection": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Cathodic Protection",
      "folder": "Pipeline Specs",
    },
  },
  "cathodic_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Cathodic Protection Type",
      "folder": "Pipeline Specs",
      "subFolder": "BC Specs",
    },
  },
  "mop_stress_percent_of_smys": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "MOP Stress % of SMYS",
      "folder": "Pipeline Specs",
      "subFolder": "BC Specs",
    },
  },
  "pressure_test_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Pressure Test Date",
      "folder": "Pipeline Specs",
      "subFolder": "BC Specs",
    },
  },
  "material_standard": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Material Standard",
      "folder": "Pipeline Specs",
    },
  },
  "from_fac": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "From Facility",
      "folder": "Location",
    },
  },
  "from_loc": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "From Location",
      "folder": "Location",
      "tnum": true,
    },
    "gpt": {
      "hint": "DLS/NTS location, e.g. '01-01-001-01W1' or 'X-001-X/001-X-01'; pad your input with leading zeros",
    },
  },
  "to_fac": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "To Facility",
      "folder": "Location",
    },
  },
  "to_loc": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "To Location",
      "folder": "Location",
      "tnum": true,
    },
    "gpt": {
      "hint": "DLS/NTS location, e.g. '01-01-001-01W1' or 'X-001-X/001-X-01'; pad your input with leading zeros",
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "pipeline_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "substance_mapping": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Substance (simplified)",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
